/**
 * "Report a problem / suggest a feature". The navigation review (P0) kept it
 * out of the top bar; Dr. John (2026-10-28) asked for it on every page, so
 * the top bar now has a small icon button (FeedbackButton) as well as the
 * user menu item (every skin) and Help > Suggest a Feature in the familiar
 * skins (action `feedback.suggest`). The form gets the current page's
 * context. Mounted once by the shell.
 */
import { useLocation } from '@tanstack/react-router';
import { useEffect, useMemo } from 'react';
import { useAction } from '../../app/actions/registry.js';
import { useActiveRoute } from '../../app/layout/activeRoute.js';
import { discoverWebModules } from '../../app/modules.js';
import { registerUserMenuItem, useOptionalSession } from '../../app/shell.js';
import { areaOptions } from './logic.js';
import { RequestDialog } from './RequestDialog.js';
import { feedbackUi, useFeedbackUi } from './store.js';
import './feedback.css';

export function FeedbackHost() {
  const session = useOptionalSession();
  const { requestOpen: open, prefill } = useFeedbackUi();
  const active = useActiveRoute();
  const { pathname } = useLocation();
  const areas = useMemo(
    () =>
      areaOptions(
        discoverWebModules().map(({ manifest: m }) => ({
          id: m.id,
          title: m.title,
          hasNav: m.nav.length > 0,
        })),
      ),
    [],
  );
  const signedIn = session !== null && session !== undefined;
  useEffect(() => {
    if (!signedIn) return undefined;
    return registerUserMenuItem({
      id: 'feedback.suggest',
      label: 'Suggest a feature or report a problem',
      order: 50,
      onSelect: () => feedbackUi.openRequest(null),
    });
  }, [signedIn]);
  useAction('feedback.suggest', () => feedbackUi.openRequest(null), {
    label: 'Suggest a Feature',
    icon: 'lightbulb',
    enabled: signedIn,
  });
  if (!signedIn) return null;
  return (
    <RequestDialog
      open={open}
      onOpenChange={feedbackUi.setRequestOpen}
      areas={areas}
      active={active}
      pathname={pathname}
      prefill={prefill}
    />
  );
}
